module.exports = __webpack_public_path__ + "img/Layer 12.47aff29d.svg";